<template>
        <div v-for="(field, key) in fields" style="margin-bottom:4px;" class="flex border rounded border-gray-200 p-4 flex-col">
            <div class="field w-full px-3 mb-3">
            <JetLabel
                class="w-full"
                for="Nomor_kontrak"
                value="Nomor Kontrak"
            />
            <Input
                id="nomor_kontrak"
                v-model="field.nomor_kontrak"
                type="text"
                placeholder="Nomor Kontrak"
                class="mt-1 block w-full"
            />
            </div>
            <div class="field w-full px-3 mb-3">
            <JetLabel
                class="w-full"
                for="nomor_bast"
                value="Nomor BAST"
            />
            <Input
                id="nomor_bast"
                v-model="field.nomor_bast"
                type="text"
                placeholder="Nomor BAST"
                class="mt-1 block w-full"
            />
            </div>
            <div class="field w-full px-3 mb-3">
            <JetLabel
                class="w-full"
                for="pemberi_kerja"
                value="Pemberi Kerja"
            />
            <Input
                id="pemberi_kerja"
                v-model="field.pemberi_kerja"
                type="text"
                placeholder="Pemberi Kerja"
                class="mt-1 block w-full"
            />
            </div>
            <div class="field w-full px-3 mb-3">
                <JetLabel
                    class="w-full"
                    for="file_kontrak"
                    value="File Kontrak (.pdf)"
                />
                <Input
                    id="file_kontrak"
                    @change="onChangeFileKontrak(key,$event)"
                    type="file"
                    class="mt-1 block w-full"
                    accept="application/pdf"
                />
            </div>
            <div class="field w-full px-3 mb-3">
                <Input
                    id="nama_file_kontrak"
                    type="text"
                    readonly="true"
                    v-model="field.nama_file_kontrak"
                    class="mt-1 block w-full"
                    accept="application/pdf"
                />
            </div>
            <div class="field w-full px-3 mb-3">
                <JetLabel
                    class="w-full"
                    for="file_bast"
                    value="File BAST (.pdf)"
                />
                <Input
                    id="file_bast"
                    @change="onChangeFileBast(key,$event)"
                    type="file"
                    class="mt-1 block w-full"
                    accept="application/pdf"
                />
            </div>
            <div class="field w-full px-3 mb-3">
                <Input
                    id="nama_file_bast"
                    type="text"
                    readonly="true"
                    v-model="field.nama_file_bast"
                    class="mt-1 block w-full"
                    accept="application/pdf"
                />
            </div>
            <div class="field w-full px-3" >
                    <ButtonDelete type="button" @click="RemoveField(key)" ><i class="fas fa-times-circle"></i></ButtonDelete>
            </div>
        </div>
        <div class="field w-full px-3 mb-3 mt-5" >
            <ButtonAdd type="button" @click="AddField" label="Tambah" ><i class="fas fa-plus-circle"></i> Tambah</ButtonAdd>
        </div>
</template>

<script>
    import { defineComponent } from 'vue'
    import Input from "@/Components/Input.vue";
    import ButtonAdd from "@/Components/ButtonAdd.vue";
    import ButtonDelete from "@/Components/ButtonDelete.vue";

    import JetLabel from "@/Jetstream/Label.vue";

    export default defineComponent({
        components: {
            Input,
            ButtonAdd,
            ButtonDelete,
            JetLabel
        },
        name: 'InputRepeaterKontrak',
        props: {
            modelValue: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                fields: [{
                    nomor_kontrak: '',
                    nomor_bast: '',
                    pemberi_kerja: '',
                    file_kontrak: '',
                    file_bast: ''
                }]
            }
        },
        computed: {
            model: {
                get: function (){
                    return this.modelValue;
                },
                set: function (value) {
                    this.$emit('update:modelValue', value);
                }
            }
        },
        mounted() {
            // this.fields = Vue.util.extend([{}], this.modelValue);
            // fire.$on('reset', this.resetField);
            // this.$emit('modelValue', this.fields);
            this.fields = this.modelValue;
            // console.log(this.modelValue);
        },
        methods: {
            AddField() {
                this.$emit('modelValue', this.fields);
                this.fields.push({file_kontak: '', file_bast: ''});
                // this.fields = this.modelValue;
                // console.log(this.fields);
            },
            RemoveField(key) {
                this.fields.splice(key, 1);
            },
            resetField() {
                this.fields = [{}];
            },
            onChangeFileKontrak(item,event) {
                let file = event.target.files[0];
                this.fields[item].file_kontrak = file;
                // emit
                this.$emit('modelValue', this.fields);
                // masukan nama file ke field
                this.fields[item].nama_file_kontrak = file.name;
            },
            onChangeFileBast(item,event) {
                let file = event.target.files[0];
                this.fields[item].file_bast = file;
                // emit
                this.$emit('modelValue', this.fields);
                // masukan nama file ke field
                this.fields[item].nama_file_bast = file.name;
            }

        },
    });
</script>
